import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  readStoredLeagueScope,
  writeStoredLeagueScope,
  parseIncludeCflParam,
} from "../utils/nflLeagueScopeStorage";
import { US_MAJOR_CFL_SCOPE } from "../utils/nflLeagueScope";

export function useNflLeagueScope() {
  const [searchParams] = useSearchParams();

  const [leagueScope, setLeagueScopeState] = useState(() => {
    const fromUrl = parseIncludeCflParam(searchParams);
    if (fromUrl !== null) {
      writeStoredLeagueScope(fromUrl);
      return fromUrl;
    }
    return readStoredLeagueScope();
  });

  useEffect(() => {
    const fromUrl = parseIncludeCflParam(searchParams);
    if (fromUrl !== null) {
      writeStoredLeagueScope(fromUrl);
      setLeagueScopeState(fromUrl);
    }
    // Only run on initial mount; URL param wins once on load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setLeagueScope = (scope) => {
    writeStoredLeagueScope(scope);
    setLeagueScopeState(scope);
  };

  const includeCfl = leagueScope === US_MAJOR_CFL_SCOPE;

  const setIncludeCfl = (enabled) => {
    setLeagueScope(enabled ? US_MAJOR_CFL_SCOPE : "us-major");
  };

  return { leagueScope, setLeagueScope, includeCfl, setIncludeCfl };
}
